<aside>
  <div class="sidebar">
    <ul class="main-menu">
      @if (environmentService.clientId === '3') {
      <li>
        <a class="experiments" routerLink="/manus-bio-experiments" routerLinkActive="active"
          (click)="routeChange(false)"> Experiment</a>
      </li>
      } @else {
      @if(hasPermission('inventory')){
      @for (item1 of menu; track $index) {
      <li>
        <a class="inventory" (click)="onClick(item1)" [ngClass]="{'active': isInventory}"> {{item1.value}}</a>
        @if (item1.child?.length) {
        <ul class="sub-menu">
          @for (item2 of item1.child; track item2; let i = $index) {
          <li [ngClass]="{'inner-list': item2.child?.length, 'open': activeIndices[0] === i}">
            <a class="location" [ngClass]="{'active': menuService.activeRoutes[0] === item2.route}"
              (click)="onClick(item2,item1); toggleOpen(i, 0)">
              {{item2.value}}</a>
            @if (item2.child?.length) {
            <ul [ngClass]="{'menu-show': activeIndices[0] === i}" class="inner-menu">
              @for (item3 of item2.child; track item3; let j = $index) {
              <li
                [ngClass]="{'inner-list': item3.child?.length, 'disabled-menu': item3.route === 'patient_sample','open': activeIndices[1] === j }">
                <a [ngClass]="{'active': menuService.activeRoutes[0] === item2.route && menuService.activeRoutes[1] === item3.route}"
                  (click)="onClick(item3,item2,item1); toggleOpen(j, 1)">{{item3.value}}</a>
                @if (item3.child?.length){
                <ul [ngClass]="{'menu-show': activeIndices[1] === j}" class="inner-menu ">
                  @for (item4 of item3.child; track item4; let k = $index) {
                  <li [ngClass]="{'inner-list': item4.child?.length}"> <a
                      [ngClass]="{'active': menuService.activeRoutes[0] === item2.route && menuService.activeRoutes[1] === item3.route && menuService.activeRoutes[2] === item4.route}"
                      (click)="onClick(item4,item3,item2,item1); toggleOpen(k, 2)">{{item4.value}}</a>
                    @if (item4.child?.length){
                    <ul class="inner-menu" [ngClass]="{'menu-show': activeIndices[2] === k}">
                      @for (item5 of item4.child; track $index) {
                      <li> <a
                          [ngClass]="{'active': menuService.activeRoutes[0] === item2.route && menuService.activeRoutes[1] === item3.route && menuService.activeRoutes[2] === item4.route && menuService.activeRoutes[3] === item5.route}"
                          (click)="onClick(item5,item4,item3,item2,item1)">{{item5.value}}</a>
                      </li>
                      }
                    </ul>
                    }
                  </li>
                  }
                </ul>
                }
              </li>
              }
            </ul>
            }
          </li>
          }
        </ul>
        }
      </li>
      }
      }
      @if(hasPermission('protocols')){
      <li>
        <a routerLink="/protocols" class="protocols" routerLinkActive="active" (click)="routeChange(false)">
          Protocols</a>
      </li>
      }
      @if(hasPermission('projects')){
      <li>
        <a class="project" routerLink="/projects" routerLinkActive="active" (click)="routeChange(false)"> Projects</a>
      </li>
      }
      @if(hasPermission('products')){
      <li>
        <a class="product" routerLink="/products" routerLinkActive="active"> Products</a>
      </li>
      }
      @if(hasPermission('vendors')){
      @for (vItem of vendorMenu; track $index) {
      <li>
        <a class="vendors" (click)="onClick(vItem)" [ngClass]="{'active': isVedors}"> {{vItem.value}}</a>
        @if (vItem.child?.length) {
        <ul class="sub-menu">
          @for (vItem1 of vItem.child; track vItem1) {
          <li class="inner-list">
            <a class="location location-without-arrow" (click)="onClick(vItem1,vItem)">
              {{vItem1.value}}</a>
          </li>
          }
        </ul>
        }
      </li>
      }
      <!-- <li>
          <a routerLink="/vendors" class="vendors" routerLinkActive="active" (click)="routeChange(false)"> Vendors</a>
        </li> -->
      }
      @if (environmentService.clientId !== '2') {
      <li>
        <a class="search-menu" routerLinkActive="active" (click)="routeChange(false)"> Search</a>
      </li>
      }
      @if (environmentService.clientId === '1') {
      <li>
        <a class="experiments" routerLink="/experiments" routerLinkActive="active" (click)="routeChange(false)">
          Experiment</a>
      </li>
      <li>
        <a class="studies" routerLink="/study-list" routerLinkActive="active" (click)="routeChange(false)"> Studies</a>
      </li>
      }

      }

      @if(hasPermission('settings')){
      <li>
        <a class="settings" routerLink="/settings" routerLinkActive="active" (click)="routeChange(false)"> Settings</a>
      </li>
      }
      <li>
        <a class="help-desk" routerLink="/help-desk" routerLinkActive="active" (click)="routeChange(false)"> Help
          Desk</a>
      </li>
    </ul>
  </div>
</aside>